var _style, _g, _g2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicPasswordSuccessmin = function SvgGraphicPasswordSuccessmin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251,
    height: 147,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes asterisk1Animation{0%,10%,to{opacity:0}20%,80%{opacity:1}}@keyframes asterisk2Animation{0%,20%,to{opacity:0}30%,80%{opacity:1}}@keyframes asterisk3Animation{0%,30%,to{opacity:0}40%,80%{opacity:1}}@keyframes twinkle{0%,to{transform:scale(.9);opacity:.2}50%{transform:scale(1.1);opacity:1}}@keyframes drawCheckmark{0%{stroke-dasharray:100;stroke-dashoffset:100;opacity:0}10%,80%{opacity:1}50%{stroke-dasharray:100;stroke-dashoffset:100}60%{stroke-dashoffset:0}to{opacity:0;stroke-dashoffset:0}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5194_14463)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.886 64.891c-.194 0-.386.01-.579.015l.001-.015c0-17.06-13.865-30.891-30.967-30.891-13.889 0-25.641 9.12-29.568 21.685a21.3 21.3 0 0 0-9.922-2.444c-11.78 0-21.329 9.526-21.329 21.277 0 1.914.258 3.767.733 5.532a17.2 17.2 0 0 0-6.995-1.486c-9.532 0-17.26 7.709-17.26 17.218S39.728 113 49.26 113h98.626C161.204 113 172 102.23 172 88.945s-10.796-24.054-24.114-24.054"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5194_14463)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.602 75.853c.15 0 .298.007.447.01l-.001-.01c0-13.174 10.696-23.853 23.889-23.853 10.714 0 19.78 7.042 22.81 16.744a16.4 16.4 0 0 1 7.654-1.887c9.087 0 16.453 7.355 16.453 16.429a16.4 16.4 0 0 1-.565 4.271 13.3 13.3 0 0 1 5.396-1.147c7.354 0 13.315 5.953 13.315 13.295 0 7.343-5.961 13.295-13.315 13.295h-76.083C119.328 113 111 104.684 111 94.426s8.328-18.573 18.602-18.573"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.143,
    height: 40.857,
    x: 47,
    y: 98,
    fill: "#1CC5A0",
    rx: 20.429
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88.868 120.382c.186.187.373.373.373.56.186.186.186.373 0 .746l-1.866 3.173c-.187.186-.373.373-.56.373s-.373 0-.56-.187l-3.919-2.985.56 5.038c0 .187 0 .56-.186.56-.187.186-.374.373-.56.373h-3.732c-.187 0-.374-.187-.56-.373-.187-.187-.187-.373-.187-.56l.56-5.225-4.105 2.986c-.187.186-.374.186-.747.186-.186 0-.373-.186-.56-.373l-1.679-3.172c-.187-.187-.187-.374 0-.747 0-.186.187-.373.373-.56l4.665-1.866-4.665-2.052c-.186 0-.373-.187-.373-.56-.187-.187-.187-.56 0-.747l1.68-2.985c.186-.187.373-.373.56-.373.186 0 .56 0 .746.186l4.105 3.172-.56-4.851c0-.187 0-.56.187-.747.186-.186.373-.373.56-.373h3.545c.187 0 .56.187.56.373.187.187.187.373.187.747l-.747 5.038 4.106-2.986c.186-.186.373-.186.746-.186.187 0 .373.186.56.373l1.68 3.172c.186.187.186.373 0 .747 0 .186-.187.373-.374.56l-4.665 2.052z",
    style: {
      animation: "asterisk1Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.555 120.569q.28 0 .56.559c.186.187.186.374 0 .747l-1.68 2.986c-.186.186-.373.373-.56.373-.186 0-.559 0-.746-.187l-3.919-2.985.56 5.038c0 .187 0 .56-.187.56-.186.186-.559.186-.746.186h-3.546c-.186 0-.559-.186-.559-.373-.187-.186-.187-.373-.187-.56l.56-5.225-4.106 3.173c-.186.186-.373.186-.746.186-.187 0-.373-.186-.56-.373l-1.679-3.172c-.187-.187-.187-.374 0-.747 0-.186.186-.373.373-.56l4.665-1.866-4.665-2.052c-.187 0-.373-.187-.373-.56-.187-.187-.187-.56 0-.747l1.866-2.985c.186-.187.373-.373.56-.373.186 0 .373.186.559.373l4.106 2.985-.56-4.851c0-.187 0-.56.187-.747.186-.186.373-.373.559-.373h3.546c.187 0 .56.187.56.373.186.187.186.373.186.747l-.746 4.851 4.292-2.985c.187-.187.373-.187.56-.187.186 0 .373.187.56.373l1.679 3.173c.187.186.187.373 0 .746 0 .187-.187.373-.373.56l-4.665 2.053z",
    style: {
      animation: "asterisk2Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.053 120.569c.187.186.373.373.373.559.187.187.187.374 0 .747l-1.866 3.172c-.186.187-.373.373-.56.373-.186 0-.559 0-.746-.186l-3.732-2.986.56 5.039c0 .186 0 .559-.187.746s-.373.187-.56.187h-3.732c-.187 0-.373-.187-.56-.374-.186-.186-.186-.373-.186-.559l.559-5.225-4.105 2.985c-.187.187-.373.187-.746.187-.187 0-.374-.187-.56-.373l-1.68-3.173c-.186-.186-.186-.373 0-.746 0-.187.187-.373.374-.56l4.478-1.866-4.665-2.053c-.187 0-.373-.186-.373-.56-.187-.186-.187-.559 0-.746l1.866-2.986c.186-.186.373-.373.56-.373.186 0 .559 0 .746.187l4.105 2.985-.559-5.038c0-.187 0-.56.186-.746.187-.187.373-.187.56-.187h3.546c.186 0 .373.187.559.373.187.187.187.373.187.56l-.746 5.225 4.105-2.986c.187-.186.373-.186.746-.186.187 0 .374.186.56.373l1.68 3.172c.186.187.186.373 0 .747 0 .186-.187.373-.374.56l-4.665 2.052z",
    style: {
      animation: "asterisk3Animation 5s infinite ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m153.143 116.547 10 10 15.244-17.12",
    style: {
      animation: "drawCheckmark 5s ease-in forwards infinite"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 2.5s infinite ease-in-out alternate",
      transformOrigin: "163px 35px"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M156.422 28.018a.49.49 0 0 1 .385-.484c.955-.171 3.579-.788 4.474-1.674s1.503-3.507 1.679-4.475a.474.474 0 0 1 .475-.385v7.018z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M163.4 21.003a.484.484 0 0 1 .476.403c.158.946.749 3.528 1.635 4.483s3.528 1.511 4.543 1.687a.48.48 0 0 1 .394.48H163.4z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M170.448 28.02a.47.47 0 0 1-.407.474c-.955.159-3.631.745-4.53 1.636s-1.477 3.528-1.636 4.53a.48.48 0 0 1-.475.428V28.02z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M163.435 28.02v7.021a.505.505 0 0 1-.475-.402c-.176-.964-.792-3.627-1.679-4.522-.886-.895-3.511-1.468-4.461-1.627a.474.474 0 0 1-.398-.47z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3s infinite ease-in-out alternate",
      transformOrigin: "174px 63px"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M158.148 63.34a.726.726 0 0 1 .591-.732c1.443-.26 5.429-1.203 6.791-2.543s2.282-5.326 2.535-6.79a.72.72 0 0 1 .728-.592v10.658z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M168.746 52.683a.73.73 0 0 1 .719.612c.244 1.435 1.139 5.357 2.488 6.808 1.348 1.452 5.356 2.295 6.893 2.57a.734.734 0 0 1 .595.731h-10.704z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M179.441 63.34a.695.695 0 0 1-.612.715c-1.456.248-5.515 1.138-6.877 2.487-1.361 1.349-2.243 5.352-2.488 6.876a.73.73 0 0 1-.719.63V63.344z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M168.801 63.34v10.656a.766.766 0 0 1-.728-.612c-.262-1.46-1.204-5.506-2.544-6.85-1.34-1.345-5.33-2.231-6.773-2.475a.72.72 0 0 1-.608-.71z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3.5s infinite ease-in-out alternate",
      transformOrigin: "141px 47.5px"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M122.998 47.526a1.27 1.27 0 0 1 1.017-1.267c2.492-.473 9.372-2.071 11.722-4.384 2.35-2.312 3.939-9.192 4.388-11.722a1.25 1.25 0 0 1 1.263-1.016v18.39z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M141.289 29.136a1.25 1.25 0 0 1 1.234 1.055c.426 2.477 1.967 9.244 4.298 11.75s9.226 3.958 11.893 4.407a1.266 1.266 0 0 1 1.03 1.267h-18.441z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M159.744 47.527a1.215 1.215 0 0 1-1.059 1.239c-2.506.425-9.514 1.957-11.864 4.288s-3.873 9.235-4.298 11.87a1.26 1.26 0 0 1-1.234 1.082v-18.48z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M141.388 47.527v18.39a1.32 1.32 0 0 1-1.253-1.055c-.45-2.52-2.076-9.5-4.388-11.822-2.313-2.321-9.198-3.849-11.694-4.255a1.26 1.26 0 0 1-1.045-1.23z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5194_14463",
    width: 204,
    height: 143,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5194_14463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5194_14463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5194_14463",
    width: 172,
    height: 125,
    x: 79,
    y: 18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5194_14463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5194_14463",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicPasswordSuccessmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_password_success.min.c015907295da5968c52f9b3042635aaa.svg";